import { Component } from '@angular/core'
import { Platform, App } from 'ionic-angular'
import { StatusBar } from '@ionic-native/status-bar'
import { SplashScreen } from '@ionic-native/splash-screen'
import { AuthService, UserService } from '../services'
import { GoogleAnalytics } from '@ionic-native/google-analytics'
import { TranslateService } from '@ngx-translate/core'

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage:any

  constructor(
    platform: Platform,
    statusBar: StatusBar,
    splashScreen: SplashScreen,
    app: App,
    auth: AuthService,
    private userService: UserService,
    private ga: GoogleAnalytics,
    private translate: TranslateService,
  ) {
    this.translate.setDefaultLang('en')

    const lang = navigator.language && navigator.language.split('-')[0] // ja-JPなどに対応
    this.translate.use(lang)

    platform.ready().then(() => {
      this.ga.startTrackerWithId('UA-111271585-1')

      // 認証状態に応じてログインページかホームページに遷移
      auth.getToken().then((token) => {
        if(auth.authenticated(token)) {
          auth.authorized()
          this.userService.getCurrentUser().subscribe((user) => {
            this.ga.setUserId(user.loginId)
            app.getRootNav().setRoot('HomePage')
          }, () => {
            app.getRootNav().setRoot('LoginPage')
          })
        } else {
          app.getRootNav().setRoot('LoginPage')
        }
      })

      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault()
      splashScreen.hide()

      app.viewDidEnter.subscribe(a => {
        const name = a.id
        if (name.match(/^.*Page$/)) { // Page以外は無視する
          this.ga.trackView(name)
        }
      })
    })
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts